// Live state shape
const initialState = {
  activeLives: [],
  currentLive: null,
  isHost: false,
  viewerCount: 0,
  chat: [],
  reactions: [],
  loading: false,
  error: null,
  stream: null,
  isRecording: false,
};

// Action types
export const LIVE_ACTIONS = {
  SET_LOADING: "LIVE_SET_LOADING",
  SET_ERROR: "LIVE_SET_ERROR",
  SET_ACTIVE_LIVES: "LIVE_SET_ACTIVE_LIVES",
  ADD_ACTIVE_LIVE: "LIVE_ADD_ACTIVE_LIVE",
  REMOVE_ACTIVE_LIVE: "LIVE_REMOVE_ACTIVE_LIVE",
  SET_CURRENT_LIVE: "LIVE_SET_CURRENT_LIVE",
  CLEAR_CURRENT_LIVE: "LIVE_CLEAR_CURRENT_LIVE",
  SET_IS_HOST: "LIVE_SET_IS_HOST",
  SET_VIEWER_COUNT: "LIVE_SET_VIEWER_COUNT",
  ADD_VIEWER: "LIVE_ADD_VIEWER",
  REMOVE_VIEWER: "LIVE_REMOVE_VIEWER",
  SET_CHAT: "LIVE_SET_CHAT",
  ADD_CHAT_MESSAGE: "LIVE_ADD_CHAT_MESSAGE",
  ADD_REACTION: "LIVE_ADD_REACTION",
  CLEAR_REACTIONS: "LIVE_CLEAR_REACTIONS",
  SET_STREAM: "LIVE_SET_STREAM",
  SET_IS_RECORDING: "LIVE_SET_IS_RECORDING",
  UPDATE_LIVE_SETTINGS: "LIVE_UPDATE_SETTINGS",
  RESET: "LIVE_RESET",
};

export function liveReducer(state = initialState, action) {
  switch (action.type) {
    case LIVE_ACTIONS.SET_LOADING:
      return { ...state, loading: action.payload };

    case LIVE_ACTIONS.SET_ERROR:
      return { ...state, error: action.payload, loading: false };

    case LIVE_ACTIONS.SET_ACTIVE_LIVES:
      return { ...state, activeLives: action.payload, loading: false };

    case LIVE_ACTIONS.ADD_ACTIVE_LIVE: {
      // Evitar duplicatas
      const exists = state.activeLives.some(
        (live) => live._id === action.payload._id
      );
      if (exists) return state;
      return {
        ...state,
        activeLives: [action.payload, ...state.activeLives],
      };
    }

    case LIVE_ACTIONS.REMOVE_ACTIVE_LIVE:
      return {
        ...state,
        activeLives: state.activeLives.filter(
          (live) => live._id !== action.payload
        ),
      };

    case LIVE_ACTIONS.SET_CURRENT_LIVE:
      return {
        ...state,
        currentLive: action.payload,
        loading: false,
      };

    case LIVE_ACTIONS.CLEAR_CURRENT_LIVE:
      return {
        ...state,
        currentLive: null,
        isHost: false,
        viewerCount: 0,
        chat: [],
        reactions: [],
        stream: null,
        isRecording: false,
      };

    case LIVE_ACTIONS.SET_IS_HOST:
      return { ...state, isHost: action.payload };

    case LIVE_ACTIONS.SET_VIEWER_COUNT:
      return { ...state, viewerCount: action.payload };

    case LIVE_ACTIONS.ADD_VIEWER:
      return {
        ...state,
        viewerCount: state.viewerCount + 1,
        currentLive: state.currentLive
          ? {
              ...state.currentLive,
              viewers: [...(state.currentLive.viewers || []), action.payload],
            }
          : null,
      };

    case LIVE_ACTIONS.REMOVE_VIEWER:
      return {
        ...state,
        viewerCount: Math.max(0, state.viewerCount - 1),
      };

    case LIVE_ACTIONS.SET_CHAT:
      return { ...state, chat: action.payload };

    case LIVE_ACTIONS.ADD_CHAT_MESSAGE: {
      // Limitar histórico do chat a 200 mensagens
      const newChat = [...state.chat, action.payload];
      if (newChat.length > 200) {
        return { ...state, chat: newChat.slice(-200) };
      }
      return { ...state, chat: newChat };
    }

    case LIVE_ACTIONS.ADD_REACTION:
      // Adicionar reação com ID único para animação
      return {
        ...state,
        reactions: [
          ...state.reactions,
          { ...action.payload, id: Date.now() + Math.random() },
        ],
      };

    case LIVE_ACTIONS.CLEAR_REACTIONS:
      // Limpar reações antigas (mais de 3 segundos)
      const now = Date.now();
      return {
        ...state,
        reactions: state.reactions.filter((r) => now - r.id < 3000),
      };

    case LIVE_ACTIONS.SET_STREAM:
      return { ...state, stream: action.payload };

    case LIVE_ACTIONS.SET_IS_RECORDING:
      return { ...state, isRecording: action.payload };

    case LIVE_ACTIONS.UPDATE_LIVE_SETTINGS:
      return {
        ...state,
        currentLive: state.currentLive
          ? { ...state.currentLive, settings: action.payload }
          : null,
      };

    case LIVE_ACTIONS.RESET:
      return initialState;

    default:
      return state;
  }
}

export default liveReducer;
